import React from 'react';
import Icon from '../../../components/AppIcon';

const DeliveryMetricsOverview = ({ metrics }) => {
  const kpiCards = [
    {
      label: 'Total Emails Sent',
      value: metrics?.totalEmails || 0,
      icon: 'Send',
      bgColor: 'bg-blue-500/20',
      iconColor: 'text-blue-400',
      description: 'All booking confirmations'
    },
    {
      label: 'Delivery Rate',
      value: `${metrics?.deliveryRate || 0}%`,
      icon: 'CheckCircle',
      bgColor: 'bg-green-500/20',
      iconColor: 'text-green-400',
      description: 'Successfully delivered',
      trend: metrics?.deliveryRate >= 95 ? 'excellent' : metrics?.deliveryRate >= 85 ? 'good' : 'warning'
    },
    {
      label: 'Delivered',
      value: metrics?.deliveredCount || 0,
      icon: 'MailCheck',
      bgColor: 'bg-emerald-500/20',
      iconColor: 'text-emerald-400',
      description: 'Confirmed deliveries'
    },
    {
      label: 'Bounce Rate',
      value: `${metrics?.bounceRate || 0}%`,
      icon: 'AlertTriangle',
      bgColor: 'bg-orange-500/20',
      iconColor: 'text-orange-400',
      description: 'Failed deliveries',
      trend: metrics?.bounceRate <= 2 ? 'excellent' : metrics?.bounceRate <= 5 ? 'good' : 'warning'
    },
    {
      label: 'Open Rate',
      value: `${metrics?.openRate || 0}%`,
      icon: 'Eye',
      bgColor: 'bg-purple-500/20',
      iconColor: 'text-purple-400',
      description: 'Emails opened'
    },
    {
      label: 'Avg Delivery Time',
      value: `${metrics?.avgDeliveryTimeSeconds || 0}s`,
      icon: 'Clock',
      bgColor: 'bg-teal-500/20',
      iconColor: 'text-[#1FB5A5]',
      description: 'Time to deliver'
    }
  ];

  const getTrendIndicator = (trend) => {
    if (!trend) return null;
    
    const indicators = {
      excellent: { icon: 'TrendingUp', color: 'text-green-400', label: 'Excellent' },
      good: { icon: 'Minus', color: 'text-yellow-400', label: 'Good' },
      warning: { icon: 'TrendingDown', color: 'text-red-400', label: 'Needs Attention' }
    };

    const indicator = indicators?.[trend];
    if (!indicator) return null;

    return (
      <div className={`flex items-center gap-1 text-xs ${indicator?.color} mt-1`}>
        <Icon name={indicator?.icon} size={12} />
        <span>{indicator?.label}</span>
      </div>
    );
  };

  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold text-white mb-4">Live Status Overview</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        {kpiCards?.map((kpi, index) => (
          <div 
            key={index}
            className="bg-white/10 backdrop-blur-md rounded-xl shadow-elevation-1 p-6 hover:shadow-elevation-2 transition-all duration-300 border border-white/20 hover:border-[#1FB5A5]/50"
          >
            <div className="flex items-start justify-between mb-4">
              <div className={`w-12 h-12 ${kpi?.bgColor} rounded-lg flex items-center justify-center backdrop-blur-sm`}>
                <Icon name={kpi?.icon} size={24} className={kpi?.iconColor} />
              </div>
            </div>
            <div>
              <p className="text-3xl font-bold text-white mb-1">{kpi?.value}</p>
              <p className="text-sm font-medium text-gray-300 mb-1">{kpi?.label}</p>
              <p className="text-xs text-gray-400">{kpi?.description}</p>
              {getTrendIndicator(kpi?.trend)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeliveryMetricsOverview;